<template>
  <v-btn
    :color="color"
    class="large-btn"
    :style="{ height: height }"
    :class="{ 'large-btn__uppercase': uppercase }"
    depressed
    large
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-btn>
</template>

<script>
  export default {
    name: 'LargeBtn',
    props: {
      color: {
        type: String,
        default: '',
      },
      uppercase: {
        type: Boolean,
        default: true,
      },
      height: {
        type: String,
        default: '80px',
      },
    },

  }
</script>

<style scoped lang="less">
  .v-btn.large-btn {
    font-size: 15px;
    box-shadow: 0 3px 6px #00000029 !important;
    height: 80px;
    border-radius: 10px;

    &.large-btn__uppercase {
      text-transform: uppercase;
    }
  }
</style>
